import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TimeFilter, PageType, SelectionChangeType, ComponentName, EventMappingType, SpecialOfferType } from '../models/enums';
import { ISport } from '../models/sportHierarchy/sport';
import { SportsProviderService } from './providers/sports.provider.service';
import { ModelMapperService } from './util/model.mapper.service';
import { UtilityService } from './util/utility.service';
import { IRegion } from '../models/sportHierarchy/region';
import { ICompetition } from '../models/sportHierarchy/competition.iterface';
import { ISportRegionCompetitionSelection } from '../models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { ISrcSelectionIds } from '../models/util/srcSelectionIds.interface';
import { TestModel } from '../models/testmodel';
import { StorageService } from './util/storage.service';
import { CacheService } from './cache.service';
import { IBetTypeGroupChangedNotification } from '../models/util/betTypeGroupChangedNotification.interface';
import { IBetTypeGroup } from '../models/betType/betTypeGroup.interface';
import { IBetTypeGroupingTemplateItem } from '../models/betType/betTypeGroupingTemplateItem.interface';
import { QueryParamsService } from './http/queryParams.service';
import { ConstantValues } from '../models/util/constantValues';
import { IOddSheets } from '../models/oddSheets/oddSheets.interface';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ViewConfigurations } from '../models/util/viewConfigurations';
import { IEventSrc } from '../models/event/eventSrc.interface';
import { GoogleAnalyticsService } from './google-analytics.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class SportsService {
  private timeFilterValue: TimeFilter;
  // not set on change do it later
  private isLive: boolean;
  private sportsTree: ISport[];
  // for non tree PageTypes
  private nonTreesSorts: ISport[];
  private srcSelection: ISportRegionCompetitionSelection = {} as ISportRegionCompetitionSelection;
  private srcSelectionIds: ISrcSelectionIds;
   favoriteCompetitions: ICompetition[] = [];

  private timeFilterChangedSource = new Subject<TimeFilter>();
  private sportsTreeLoadedSource = new Subject<void>();
  // private sportsTreeLiveLoadedSource = new Subject<void>();
  private srcSelectionChangedSource = new Subject<{ selectionChangeType: SelectionChangeType; callFrom: ComponentName }>();
  public srcSelectionChanged$ = this.srcSelectionChangedSource.asObservable();
  private selectedMostPopularOrEventsSoonSportIdChangedSource = new Subject<{sportId: number; eventsCount: number}>();
  public selectedMostPopularOrEventsSoonSportIdChanged$ = this.selectedMostPopularOrEventsSoonSportIdChangedSource.asObservable();
  public timeFilterChanged$ = this.timeFilterChangedSource.asObservable();
  public sportsTreeLoaded$ = this.sportsTreeLoadedSource.asObservable();
  // public sportsTreeLiveLoaded$ = this.sportsTreeLiveLoadedSource.asObservable();

  private liveSportSelectedSource = new Subject<number>();
  public liveSportSelected$ = this.liveSportSelectedSource.asObservable();

  private favoriteCompetitionSRCChangedSource = new Subject<IEventSrc>();
  public favoriteCompetitionSRCChanged$ = this.favoriteCompetitionSRCChangedSource.asObservable();


  private emptyTreeLoadedSource = new Subject<void>();
  public emptyTreeLoaded$ = this.emptyTreeLoadedSource.asObservable();
  public loadCompetitionFromBanner = false;

  private openCompetitionFromBannerSource = new Subject<void>();
  public openCompetitionFromBanner$ = this.openCompetitionFromBannerSource.asObservable();

  private selectedBetTypeGroupChangedForSRCSource = new Subject<ISrcSelectionIds>();
  public selectedBetTypeGroupForSrcChanged$ = this.selectedBetTypeGroupChangedForSRCSource.asObservable();

  private deselectSportsNotificationSource = new Subject<void>();
  public deselectSportsNotification$ = this.deselectSportsNotificationSource.asObservable();
  // private sportTreereeLoadedSource = new Subject<void>();
  // public sportTreereeLoaded$ = this.sportTreereeLoadedSource.asObservable();

  sportsForLive: ISport[] = [];
  private selectedBetTypeGroupAndTemplateItemsForSportss: { [sportId: number]: { betTypeGroup: IBetTypeGroup; betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[] } } = {};
  // selectionsForLive: IBetTypeSelection[] = [];
  // betTypeSelectionsForLiveSports: { [sportId: number]: { [betTypeId: number]: IBetTypeSelection }} = {};
  oddSheets: IOddSheets = null;
  language: string;
  languageCulture: string;
  loadCompetitionOrEventFromQuery = false;
  // private timeFilterChanged = true;

  constructor(
    private cacheService: CacheService,
    private sportsProvider: SportsProviderService,
    private queryParamsService: QueryParamsService,
    private modelMapper: ModelMapperService,
    private utilityService: UtilityService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private storage: StorageService) {

    this.setInitialSelections();
    this.queryParamsService.queryParamsChanged$.subscribe(() => this.setInitialSelections());
    // get page type before all of this and call get sports
    // if (this.pageType !== PageType.Live && this.pageType !== PageType.Help) {
    //   this.getPMSportsTreeForFilter();
    // }

    this.isLive = false;
    this.sportsTree = [];
    this.nonTreesSorts = [];
   // this.getSportsForLive();
    this.language = this.storage.language;
    this.languageCulture = LocaleHelper.cultureName[this.language];
    this.getOddSheets();
  }

  openCompetitionFromBanner(sportId: number, regionId: number, competitionId: number) {
    if (this.srcSelection.sport) {
      this.srcSelection.sport.isSelected = false;
      this.srcSelection.sport.showRegions = false;
    }
    if (this.srcSelection.region) {
      this.srcSelection.region.isSelected = false;
      this.srcSelection.region.showCompetitions = false;
    }
    if (this.srcSelection.competition) {
      this.srcSelection.competition.isExpanded = false;
      this.srcSelection.competition.isSelected = false;
    }
    this.srcSelectionIds.sId = sportId;
    this.srcSelectionIds.rId = regionId;
    this.srcSelectionIds.cId = competitionId;
    this.loadCompetitionFromBanner = true;
    this.storage.srcSelectionIdsPrematch = this.srcSelectionIds;
    this.openCompetitionFromBannerSource.next();
  }


  // public set pageTypeSet(pageType: PageType) {
  //   if (this.pageType === pageType) {
  //     return;
  //   }
  //   this.pageType = pageType;

  //   if (this.pageType !== PageType.Live) {
  //     this.isLive = false;
  //   } else {
  //     this.isLive = true;
  //   }
  // }

  // public get pageTypeGet(): PageType {
  //   return this.pageType;
  // }

  // public get isLiveGet(): boolean {
  //   return this.isLive;
  // }
  // public clearSrcSelection() {
  //   this.srcSelection.sport = null;
  //   this.srcSelection.region = null;
  //   this.srcSelection.competition = null;
  //   this.srcSelectionToSrcSelectionIds();
  // }

  public deselectSports(){
    this.deselectSportsNotificationSource.next();
  }

  selectMostPopularOrEventsSoonSport(sport: ISport, eventsCount: number = 0){
    this.selectedMostPopularOrEventsSoonSportIdChangedSource.next({sportId: sport.id, eventsCount});
  }

  public get timeFilterValueGet(): TimeFilter {
    return this.timeFilterValue;
  }

  public get sportTreeGet(): ISport[] {
    return this.sportsTree;
  }

  public get nonTreesSortsGet(): ISport[] {
    return this.nonTreesSorts;
  }

  public get sportRegionCompetitionSelection(): ISportRegionCompetitionSelection {
    return this.srcSelection;
  }

  public get selectedBetTypeGroupAndTemplateItemsForSports(): { [sportId: number]: { betTypeGroup: IBetTypeGroup; betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[] } } {
    return this.selectedBetTypeGroupAndTemplateItemsForSportss;
  }

  public getSportRegionCompetitionSelectionIds(isLive: boolean): ISrcSelectionIds {
    if (!this.srcSelection || this.srcSelectionIds.isLive !== isLive) {
      if (isLive) {
        this.srcSelectionIds = this.storage.srcSelectionIdsLive;
      } else {
        this.srcSelectionIds = this.storage.srcSelectionIdsPrematch;
      }

      // this.srcSelection.sport =  null;
      // this.srcSelection.region =  null;
      // this.srcSelection.competition =  null;

      if (this.queryParamsService.queryParameters.sportId) {
        this.srcSelectionIds.sId = this.queryParamsService.queryParameters.sportId;
        this.srcSelectionIds.rId = this.queryParamsService.queryParameters.regionId;
        this.srcSelectionIds.cId = this.queryParamsService.queryParameters.competitionId;
      }

    }

    return this.srcSelectionIds;
  }

  public getSpecialOfferSports(specialOfferType: SpecialOfferType, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions): Observable<IRegion[]> {
    return this.cacheService.getSpecialOfferSports(specialOfferType, languageCulture, dateFormat);
  }

  public changeSelectedBetTypeGroupForGroup(betTypeGroupChangedNotification: IBetTypeGroupChangedNotification){
    this.selectedBetTypeGroupAndTemplateItemsForSportss[betTypeGroupChangedNotification.sportId] = { betTypeGroup: betTypeGroupChangedNotification.betTypeGroup, betTypeGroupingTemplateItems: betTypeGroupChangedNotification.betTypeGroupingTemplateItems };
    this.selectedBetTypeGroupChangedForSRCSource.next({sId: betTypeGroupChangedNotification.sportId, rId: betTypeGroupChangedNotification.regionId, cId: betTypeGroupChangedNotification.competitionId, isLive: false} as ISrcSelectionIds);
  }

  public changeTimeFilterValue(timeFilterValue: TimeFilter, isMobile: boolean, notify: boolean = true) {

    if (this.timeFilterValue !== timeFilterValue && this.queryParamsService.pageType !== PageType.Live) {
      const date = new Date();
      if (timeFilterValue === TimeFilter.Today) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Danas', '1');

      } else if (timeFilterValue === TimeFilter.D1) {
        date.setHours(date.getHours() + 24);

        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', date.toLocaleString(this.languageCulture, { weekday: 'short'}), '1');
      } else if (timeFilterValue === TimeFilter.D2) {
        date.setHours(date.getHours() + 24 * 2);

        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', date.toLocaleString(this.languageCulture, { weekday: 'short'}), '1');
      } else if (timeFilterValue === TimeFilter.D3) {
        date.setHours(date.getHours() + 24 * 3);

        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', date.toLocaleString(this.languageCulture, { weekday: 'short'}), '1');
      } else if (timeFilterValue === TimeFilter.D4) {
        date.setHours(date.getHours() + 24 * 4);

        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', date.toLocaleString(this.languageCulture, { weekday: 'short'}), '1');
      } else if (timeFilterValue === TimeFilter.D5) {
        date.setHours(date.getHours() + 24 * 5);

        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', date.toLocaleString(this.languageCulture, { weekday: 'short'}), '1');
      } else if (timeFilterValue === TimeFilter.D6) {
        date.setHours(date.getHours() + 24 * 6);

        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', date.toLocaleString(this.languageCulture, { weekday: 'short'}), '1');
      } else if (timeFilterValue === TimeFilter.All) {
        this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Sve', '1');
      }
    } else {
      this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Uživo', '1');
    }
    this.timeFilterValue = timeFilterValue;
    this.storage.timeFilterValue = timeFilterValue;
    // if (this.timeFilterValue !== TimeFilter.All && !isMobile) {
    //   this.setSelectionsForSport(null, this.isLive);
    // }
    if (notify) {
      // this.timeFilterChanged = true;
      this.timeFilterChangedSource.next(this.timeFilterValue);
    }

  }

  private setSelectionsByQueryParams(sportId?: number, regionId?: number, competitionId?: number) {
    if (!sportId) {
      return;
    }
    this.timeFilterValue = TimeFilter.All;
    this.srcSelectionIds.sId = sportId;
    this.srcSelectionIds.rId = regionId;
    this.srcSelectionIds.cId = competitionId;

  }

  // change this later
  private setInitialSelections() {
    this.timeFilterValue = this.storage.timeFilterValue;
    if (this.timeFilterValue === TimeFilter.Live) {
      this.timeFilterValue = TimeFilter.All;
    }

    if (this.isLive) {
      this.srcSelectionIds = this.storage.srcSelectionIdsLive;
    } else {
      if (!this.utilityService.mobileView) {
        this.storage.srcSelectionIdsPrematch = null;
        if (ViewConfigurations.showFilterNavigationMenu){
          this.storage.timeFilterValue = TimeFilter.Today;
          this.timeFilterValue = TimeFilter.Today;
          this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Danas', '1');

        }else{
          this.storage.timeFilterValue = TimeFilter.All;
          this.timeFilterValue = TimeFilter.All;
        }
      }else{
        this.storage.srcSelectionIdsPrematch = null;
        if (ViewConfigurations.showFilterNavigationMenu){
          this.storage.timeFilterValue = TimeFilter.Today;
          this.timeFilterValue = TimeFilter.Today;
          this.googleAnalyticsService.eventEmitter('Odabir izbornika - filtera', 'Danas', '1');

        }else{
          this.storage.timeFilterValue = TimeFilter.All;
          this.timeFilterValue = TimeFilter.All;
        }
      }
      this.srcSelectionIds = this.storage.srcSelectionIdsPrematch;
    }

    this.srcSelection.sport =  null;
    this.srcSelection.region =  null;
    this.srcSelection.competition =  null;

    if (this.queryParamsService.queryParameters.sportId) {
      this.loadCompetitionOrEventFromQuery = true;
      this.timeFilterValue = TimeFilter.All;
      this.srcSelectionIds.sId = this.queryParamsService.queryParameters.sportId;
      this.srcSelectionIds.rId = this.queryParamsService.queryParameters.regionId;
      this.srcSelectionIds.cId = this.queryParamsService.queryParameters.competitionId;
    }
  }



  public getPMSportsTreeForFilterCache(forceGetFromServer: boolean = false): Observable<ISport[]> {
    // this.getSpecialOfferButtons();
    // const dates = this.utilityService.getDateFromTo(false, this.timeFilterValue);
    // return this.sportsProvider
    //   .getSports(dates.dateFrom, dates.dateTo, false)
    //   .pipe(
    //     switchMap((sportsTO) => {
    //       this.sportsTree = [];
    //       for (const sportTO of sportsTO) {
    //         const sport = this.modelMapper.mapSport(sportTO);
    //         this.sportsTree.push(sport);
    //         for (const regionTO of sportTO.regions) {
    //           const region = this.modelMapper.mapRegion(regionTO, sport.name);
    //           sport.regions.push(region);
    //           for (const competitionTO of regionTO.competitions) {
    //             const competition = this.modelMapper.mapCompetition(competitionTO, sport.name, region.name);
    //             region.competitions.push(competition);
    //           }
    //         }
    //       }

    //       // this.sportsTree = sports.map((s) => {
    //       //   const sports: ISport
    //       //   this.modelMapper.mapSport(s);
    //       // });
    //       this.sportTreereeLoadedSource.next();
    //       return of(this.sportsTree);
    //     })
    //   );

    return this.cacheService.getPMSportsTreeForFilter(this.timeFilterValue, forceGetFromServer);

    // .subscribe(sports => {
    //   this.sportsTree = sports;
    //   if (this.pageType === PageType.Prematch) {
    //     if (!this.srcSelectionIds.sId || !this.srcSelectionIds.rId || !this.srcSelectionIds.cId) {
    //       this.selectFirstSport(sports);
    //     }
    //     else {
    //       const sport = sports.find(s => s.id === this.srcSelectionIds.sId);
    //       if (sport) {
    //         const region = sport.regions.find(r => r.id === this.srcSelectionIds.rId);
    //         if (region) {
    //           const competition = region.competitions.find(c => c.id === this.srcSelectionIds.cId);
    //           if (competition) {
    //             this.selectSport(sport, false);
    //             this.selectRegion(region, false);
    //             this.selectCompetition(competition);
    //           }
    //           else {
    //             this.selectSport(sport, false);
    //             this.selectRegion(region, false);
    //             this.selectCompetition(region.competitions[0]);
    //           }
    //         } else {
    //           this.selectSport(sport, false);
    //           this.selectRegion(sport.regions[0]);
    //         }
    //       } else {
    //         this.selectFirstSport(this.sportsTree);
    //       }
    //     }
    //   }
    // this.sportsTreeLoadedSource.next();
    // });
  }

  public getPMSportsTreeForFilterFromServer(dateFrom: Date, dateTo: Date, isLive: boolean): Observable<ISport[]> {
    const responseSportTree = this.sportsProvider.getSports(dateFrom, dateTo, isLive, [EventMappingType.StandardEvent, EventMappingType.EventOfDay, EventMappingType.SuperBetEvent]);
    const responseSpecialOfferButtons = this.sportsProvider.getSpecialOfferButtons(dateFrom, dateTo);
    return forkJoin([responseSportTree, responseSpecialOfferButtons]).pipe(
      switchMap((responses) => {
        const sports: ISport[] = [];
        let i = 0;
        for (const sportTO of responses[0]) {
          i++;
          const sport = this.modelMapper.mapSport(sportTO, i * 2);

          sports.push(sport);

          let j = 0;
          for (const regionTO of sportTO.regions) {
            j++;
            const region = this.modelMapper.mapRegion(regionTO, sport.name, i * 100 + j);

            sport.regions.push(region);

            let k = 0;
            for (const competitionTO of regionTO.competitions) {
              k++;
              const competition = this.modelMapper.mapCompetition(competitionTO, sport.name, region.name, region.orderNo * 100 + k);
              // if (competitionTO.id === DeployParams.HIGLIGHTED_LEAGUE_ID) {
              //   const higlightedRegion: IRegion = {
              //     competitions: [],
              //     eventsCount: competition.eventsCount,
              //     id: -9999,
              //     isSelected: false,
              //     name: competition.name,
              //     shortName: 'ABA',
              //     showCompetitions: false,
              //     sportId: competition.sportId,
              //     orderNo: -9999
              //   };
              //   sport.regions.unshift(higlightedRegion);
              // }

              region.competitions.push(competition);
            }
          }
        }

        for (const specialOfferButton of responses[1]) {
          const sport = this.modelMapper.mapSportFromSpecialOfferButtonTO(specialOfferButton, this.utilityService.getSpecialOfferSportId(specialOfferButton.id));

          sports.push(sport);

          if (sport.id === this.utilityService.getSpecialOfferSportId(SpecialOfferType.Outrights)) {
            const specials = sports.find(s => s.id === environment.specialsSportId);
            if (ViewConfigurations.showOutrightsAtEnd) {
              sport.orderNo = 999999;
            } else {
              if (specials) {
                sport.orderNo = specials.orderNo - 1;
              }
            }
          }
        }
        return of(this.utilityService.sortByOrderNo(sports));
      })
    );
  }

  public notifySportsTreeIsLoaded() {
    this.sportsTreeLoadedSource.next();
  }

  public getPMSportsTreeForSportTypeFilter(specialOfferTypes: SpecialOfferType[]) {
    return this.cacheService.mapSportsToTree(specialOfferTypes);
  }

  // public selectFirstSport(sports: ISport[], selectFirstRegion: boolean = true) {
  //   const sport = sports[0];
  //   if (sport) {
  //     this.selectSport(sport, selectFirstRegion);
  //   }
  // }


  getSuperBetEvents() {
    // pass this call to events service
  }

  getEventsOfDay() {
    // pass this call to events service
  }

  getSpecialOfferButtons() {
    // not impemeneted
  }

  getSportsStartingSoon(): Observable<ISport[]> {
    return this.sportsProvider.getSportsStartingSoon(ConstantValues.NUMBER_OF_INITIAL_SPORTS_PM, false, ConstantValues.HOURS_TO_SPORTS_STARTING_SOON,  ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]).pipe(
      map(sportsTO => {
        let orderNo = 0;
        return sportsTO.map(s => this.modelMapper.mapSport(s, orderNo++, null));
      })
    );
  }

  getMostPopularSports(noOfSports?: number): Observable<ISport[]> {
    return this.sportsProvider.getMostPopularSports(noOfSports ? noOfSports : ConstantValues.NUMBER_OF_INITIAL_SPORTS_PM, false,  ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]).pipe(
      map(sportsTO => {
        let orderNo = 0;
        return sportsTO.map(s => this.modelMapper.mapSport(s, orderNo++, null));
      })
    );
  }

  getSportsForLive() {
    const sportsForLive: ISport[] = [];
    let i = 0;
    TestModel.liveSportsWithSelections.forEach((s) => {
      i++;
      const sport: ISport = this.modelMapper.mapSport({ id: s.id, eventsCount: s.eventsCount, name: s.name, regions: [] }, i);
      sportsForLive.push(sport);
      let j = 0;
      s.regions.forEach(reg => {
        j++;
        const region: IRegion = this.modelMapper.mapRegion({ id: reg.id, eventsCount: reg.eventsCount, name: reg.name, competitions: [], sportId: s.id, shortName: reg.shortName }, s.name, i * 100 + j);
        sport.regions.push(region);
        let k = 0;
        reg.competitions.forEach(cmp => {
          k++;
          const competition: ICompetition = this.modelMapper.mapCompetition({
            id: cmp.id,
            eventsCount: cmp.eventsCount,
            name: cmp.name,
            sportId: s.id,
            shortName: cmp.shortName,
            regionId: reg.id,
            events: [],
          }, s.name, reg.name, region.orderNo * 100 + k);
          sport.regions.push(region);
        });
      });
    });

    this.sportsForLive = sportsForLive;
    return this.sportsForLive;
  }

  // getSportsForLive() {
  //   this.sportsProvider.getLiveSports(null, false, false, true).pipe(
  //     map((sportsWithSelections) => {
  //     const sports = sportsWithSelections.map((sportWithSelections) => {
  //      return this.modelMapper.mapSport(sportWithSelections);
  //     });
  //     })).subscribe();
  // }

  setSportIdForEventLive(sportId: number) {
    this.liveSportSelectedSource.next(sportId);
  }

  getTodayOfferSports() {
    // not impemeneted
  }

  getSportsForTodayOffer() {
    // not impemeneted
  }

  getSportsForHomePage() {
    // not impemeneted
    // eslint-disable-next-line max-len
    // za sve ove dodatne sportove(koji ce biti prikazani i pored tree napravi jos jedan observer kad se uradi load- u sustini to ce biti onaj za events header subscriber)
  }

  public selectSportNotify(sport: ISport, isLive: boolean, callFrom: ComponentName) {
    // if (this.setSelectionsForSport(sport, isLive)) {
      this.setSelectionsForSport(sport, isLive);
      this.utilityService.changeParentSrcUrl(sport?.id, sport?.name);
      this.srcSelectionChangedSource.next({ selectionChangeType: SelectionChangeType.Sport, callFrom });
    // }
  }

  public selectRegionNotify(region: IRegion, sport: ISport, isLive: boolean, callFrom: ComponentName/*, selectFirstCompetition: boolean = true*/) {
    // if (this.setSelectionsForRegion(region, sport, isLive)) {
      this.setSelectionsForRegion(region, sport, isLive);
      this.utilityService.changeParentSrcUrl(sport?.id, sport?.name, region?.id, region?.name);
      this.srcSelectionChangedSource.next({ selectionChangeType: !sport.specialOfferType ? SelectionChangeType.Region : SelectionChangeType.Sport, callFrom });
    // }
  }

  // prob could be moved to new service -competition events comunication
  public selectCompetitionNotify(competition: ICompetition, region: IRegion, sport: ISport, isLive: boolean, callFrom: ComponentName) {
    // if (this.setSelectionsForCompetition(competition, region, sport, isLive)) {
    this.setSelectionsForCompetition(competition, region, sport, isLive);
    this.utilityService.changeParentSrcUrl(sport?.id, sport?.name, region?.id, region?.name, competition?.id, competition?.name);
    this.srcSelectionChangedSource.next({ selectionChangeType: SelectionChangeType.Competition, callFrom });
    // }
    if (!this.queryParamsService.queryParameters.eventId && this.loadCompetitionOrEventFromQuery) {
      this.loadCompetitionOrEventFromQuery = false;
    }
  }

  public setSelectionsForSport(sport: ISport, isLive: boolean) {
    // let notify = true;
    // if (this.srcSelection.sport?.id === sport?.id && !this.srcSelection.region && !this.srcSelection.competition) {
    //   notify = false;
    // }
    this.clearSelectionsForSelectedSport();
    this.srcSelection.sport = sport;
    this.saveSrcSelectionIds(isLive);
    // return notify;
  }

  public setSelectionsForRegion(region: IRegion, sport: ISport, isLive: boolean) {
    // let notify = true;
    // if (this.srcSelection.sport?.id === sport?.id && this.srcSelection.region?.id === region?.id  && !this.srcSelection.competition) {
    //   this.timeFilterChanged = false;
    //   notify = false;
    // }
    this.clearSelectionsForSelectedRegion();
    this.srcSelection.sport = sport;
    this.srcSelection.region = region;
    this.saveSrcSelectionIds(isLive);
    // return notify;
  }

  public setSelectionsForCompetition(competition: ICompetition, region: IRegion, sport: ISport, isLive: boolean) {
    // let notify = true;
    // if (this.srcSelection.sport?.id === sport?.id && this.srcSelection.region?.id === region?.id  && this.srcSelection.competition?.id === competition?.id && !this.timeFilterChanged) {
    //   notify = false;
    //   this.timeFilterChanged = false;
    // }
    this.clearSelectionsForSelectedCompetition();
    this.srcSelection.competition = competition;
    this.srcSelection.region = region;
    this.srcSelection.sport = sport;
    this.saveSrcSelectionIds(isLive);
    // return notify;
  }

  saveSrcSelectionIds(isLive: boolean) {
    if (isLive) {
      this.storage.srcSelectionIdsLive = this.srcSelectionToSrcSelectionIds();
    } else {
      this.storage.srcSelectionIdsPrematch = this.srcSelectionToSrcSelectionIds();
    }
  }

  public clearSelectionsForSelectedSport() {
    if (!this.srcSelection.sport) {
      return;
    }
    // this.srcSelection.sport.isSelected = false;
    // this.srcSelection.sport.showRegions = false;

    this.clearSelectionsForSelectedRegion();
    this.clearSelectionsForSelectedCompetition();
    this.srcSelection.sport = null;
  }

  public clearSelectionsForSelectedRegion() {
    if (!this.srcSelection.region) {
      return;
    }
    // this.srcSelection.region.isSelected = false;
    // this.srcSelection.region.showCompetitions = false;
    this.srcSelection.region = null;
    this.clearSelectionsForSelectedCompetition();
  }

  public clearSelectionsForSelectedCompetition() {
    if (!this.srcSelection.competition) {
      return;
    }
    // this.srcSelection.competition.isSelected = false;
    this.srcSelection.competition = null;
  }

  private srcSelectionToSrcSelectionIds(): ISrcSelectionIds {
    if (this.srcSelection.sport) {
      this.srcSelectionIds.sId = this.srcSelection.sport.id;
    } else {
      this.srcSelectionIds.sId = null;
    }

    if (this.srcSelection.region) {
      this.srcSelectionIds.rId = this.srcSelection.region.id;
    } else {
      this.srcSelectionIds.rId = null;
    }

    if (this.srcSelection.competition) {
      this.srcSelectionIds.cId = this.srcSelection.competition.id;
    } else {
      this.srcSelectionIds.cId = null;
    }
    return this.srcSelectionIds;
  }

  public notifyEmptyTreeLoaded() {
    this.emptyTreeLoadedSource.next();
  }

  public downloadListPdf(fileName: string, isMainList: boolean) {
    // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //   const isEdgeOrIE = true;
    // } else {
    //   // if (openInNewTab) {//added if not links but span
    //   const newWindow = window.open(); //if not made this way- pop-us are blocked because async calls, so tab is opened first and after response file is added to tab
    //   // }
    // }

    let fileNameToSave = fileName;
    if (isMainList) {
      fileNameToSave = DynamicTranslations.otherTranslations_ListNo + ' ' + fileName;
    }

    this.sportsProvider.downloadListPdf(fileName, isMainList).subscribe(blob => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileNameToSave + '.pdf';
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  getSportTreeForResultPage(timeFilter: TimeFilter): Observable<ISport[]> {
    const dates = this.utilityService.getDateFromTo(false, timeFilter);
    return this.sportsProvider.getSportTreeForResults(dates.dateFrom, dates.dateTo).pipe(
      map(sportsTO => {
        const sports: ISport[] = [];
        let i = 0;
        let j = 0;
        let k = 0;
        for (const sportTO of sportsTO) {
          i++;
          const sport = this.modelMapper.mapSport(sportTO, i);
          sports.push(sport);
          for (const regionTO of sportTO.regions) {
            j++;
            const region = this.modelMapper.mapRegion(regionTO, sport.name, j);
            sport.regions.push(region);
            for (const competitionTO of regionTO.competitions) {
              k++;
              const competition = this.modelMapper.mapCompetition(competitionTO, sport.name, region.name, k);
              region.competitions.push(competition);
            }
          }
        }
        return sports;
      })
    );
  }


  public getOddSheets(): Observable<IOddSheets> {
    if (!this.oddSheets) {
      return this.sportsProvider.getOddsheets().pipe(
        map(oddSheetsTO => {
          if (this.oddSheets) {
            this.oddSheets = this.modelMapper.mapOddSheets(oddSheetsTO, this.languageCulture);
          } else {
            this.oddSheets = null;
          }
          return this.oddSheets;
        }));
    } else {
      return of(this.oddSheets);
    }
  }

  addRemoveCompetitionToFavorites(competition: ICompetition, eventId = null) {
    const eventSRCTemp: IEventSrc = {
      sportId: competition.sportId,
      regionId: competition.regionId,
      competitionId: competition.id,
      eventId,
      addedDate: new Date(),
    };
    const favCompetitionInd = this.favoriteCompetitions.findIndex(c => c.id === competition.id);
    if (competition.isInFavorites) {
      if (eventId) {
        competition.isInFavorites = !competition.isInFavorites;
      }
      if (favCompetitionInd < 0) {
        return;
      }
      this.favoriteCompetitions.splice(favCompetitionInd, 1);
      this.storage.favoriteCompetitions = this.favoriteCompetitions;

      this.favoriteCompetitionSRCChangedSource.next(eventSRCTemp);

    } else {
      if (eventId) {
        competition.isInFavorites = !competition.isInFavorites;
      }
      if (favCompetitionInd < 0) {
        this.favoriteCompetitions.push(competition);
      }
      this.storage.favoriteCompetitions = this.favoriteCompetitions;
      this.favoriteCompetitionSRCChangedSource.next(eventSRCTemp);
    }

  }


}
